module.exports = __webpack_public_path__ + "media/images/official/about_yamori_musashishinjoua-08cff306b3ec5bb1e8f59773c2614df7.jpg";